import { NavigateFunction } from 'react-router-dom';
import { apiService } from './apiService';

interface  LoginData {
    email: string;
    password: string;
}

interface  ForgotPasswordData {
    email: string;
}

interface ResetPasswordData {
    token: string;
    newPassword: string;
    confirmPassword: string;
}

const UserService = {

    login: async (data: LoginData, navigate: NavigateFunction) => {
        return apiService.post('/users/login', data, { withCredentials: true }, navigate);
    },

    logout: async (navigate?: NavigateFunction) => {
        try {
            await apiService.post('/users/logout', {}, { withCredentials: true });
            sessionStorage.clear();
            //localStorage.removeItem('rememberedEmail');

            if (navigate) {
                navigate('/login');
            }
        } catch (error) {
            console.error("Logout failed", error);
        }
    },

    getUserByEmail: async (email: string) => {
        return apiService.get(`/users`, { params: { email } });
    },

    updateUser: async (userId: string, updateData: Record<string, any>) => {
        return apiService.put(`/users/${userId}`, updateData);
    },

    deleteUser: async (userId: string) => {
        return apiService.delete(`/users/${userId}`);
    },

    forgotPassword: async (data: ForgotPasswordData) => {
        return apiService.post(`/users/forgot-password`,data);
    },

    resetPassword: async (data: ResetPasswordData) => {
        return apiService.post(`/users/reset-password`,data);
    }


};

export default UserService;
